// src/REDAirCalculator.Frontend/scripts/modal-helpers.ts
import emitter from "./event-bus";
import type { ModalProps } from "../src/types/modal.types";

/**
 * Helper function to open modals from anywhere in the codebase,
 * including from non-Vue code like vanilla JS or Razor pages
 *
 * @param modalName - The name of the modal component file (without .vue extension)
 * @param modalProps - Props to pass to the modal
 */
export function openModal(modalName: string, modalProps: Partial<ModalProps> = {}) {
    // Ensure all required properties for the modal are present
    if (modalName === "NoteModal") {
        if (!modalProps.id) {
            throw new Error("The 'id' property is required for NoteModal.");
        }
    }
    emitter.emit("open-modal", {
        modalName,
        modalProps: {
            ...modalProps,
            modalType: modalProps.modalType || modalName,
        } as ModalProps,
    });
}

export function closeModal() {
    emitter.emit("close-modal");
}

if (!window.RedAir) {
    window.RedAir = {};
}

window.RedAir.openModal = openModal;
window.RedAir.closeModal = closeModal;
